var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass: "navBar",
      class: [
        _vm.expanded ? "expanded" : "collapsed",
        _vm.darkMode ? "dark" : "light",
      ],
    },
    [
      _vm.sideLinks.length > 0
        ? _c(
            "div",
            { staticClass: "sideBar", on: { click: _vm.sidebarClicked } },
            [
              _c("div", { staticClass: "logoHolder" }, [
                _vm.expanded && !_vm.darkMode
                  ? _c("img", {
                      staticClass: "logo",
                      attrs: { src: _vm.logoUrl },
                      on: { click: _vm.logoClicked },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.expanded && _vm.darkMode
                  ? _c("img", {
                      staticClass: "logo",
                      attrs: { src: _vm.darkModeLogoUrl },
                      on: { click: _vm.logoClicked },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.showSidebarToggle
                ? _c(
                    "a",
                    {
                      staticClass: "toggleDetails",
                      attrs: { role: "button", tabindex: "0" },
                      on: {
                        click: _vm.handleSidebarToggle,
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.handleSidebarToggle.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm.expanded
                        ? _c("i", { staticClass: "icon fal fa-chevron-left" })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.expanded
                        ? _c("i", { staticClass: "icon fal fa-chevron-right" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Toggle navigation"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.expanded
                ? _c(
                    "span",
                    {
                      ref: "menuButton",
                      staticClass: "menuButton",
                      class: _vm.menuOpen ? "active" : "",
                      attrs: { tabindex: "0" },
                      on: {
                        click: _vm.toggleMenu,
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.toggleMenu.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm.currentProduct === "monitoring"
                        ? _c("span", { staticClass: "buttonText currentApp" }, [
                            _c("i", {
                              staticClass:
                                "productIcon fal fa-monitor-heart-rate",
                            }),
                            _vm._v(" "),
                            _vm._m(0),
                            _vm._v(" "),
                            _c("i", {
                              class: {
                                toggleIcon: true,
                                "fal fa-chevron-left": _vm.menuOpen,
                                "fal fa-chevron-right": !_vm.menuOpen,
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentProduct === "analytics"
                        ? _c("span", { staticClass: "buttonText currentApp" }, [
                            _c("i", {
                              staticClass:
                                "productIcon fal fa-monitor-heart-rate",
                            }),
                            _vm._v(" "),
                            _vm._m(1),
                            _vm._v(" "),
                            _c("i", {
                              class: {
                                toggleIcon: true,
                                "fal fa-chevron-left": _vm.menuOpen,
                                "fal fa-chevron-right": !_vm.menuOpen,
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentProduct === "workspaces"
                        ? _c("span", { staticClass: "buttonText currentApp" }, [
                            _c("i", {
                              staticClass: "productIcon fal fa-map-marked-alt",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "productName oneLine" }, [
                              _vm._v("\n          Space Insights\n        "),
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              class: {
                                toggleIcon: true,
                                "fal fa-chevron-left": _vm.menuOpen,
                                "fal fa-chevron-right": !_vm.menuOpen,
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentProduct === "admin"
                        ? _c("span", { staticClass: "buttonText currentApp" }, [
                            _c("i", {
                              staticClass: "productIcon fal fa-toolbox",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "productName oneLine" }, [
                              _vm._v("Admin Portal"),
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              class: {
                                toggleIcon: true,
                                "fal fa-chevron-left": _vm.menuOpen,
                                "fal fa-chevron-right": !_vm.menuOpen,
                              },
                            }),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.menuOpen
                ? _c(
                    "div",
                    {
                      ref: "popup",
                      class: { navPopup: true, slideIn: _vm.menuOpen },
                    },
                    [
                      _c("section", { staticClass: "options" }, [
                        _c("section", { staticClass: "applications" }, [
                          _c("span", { staticClass: "section-title" }, [
                            _vm._v("Applications"),
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "optionList" }, [
                            _c("li", { staticClass: "techInsights" }, [
                              _vm._m(2),
                              _vm._v(" "),
                              _c("ul", { staticClass: "sub-apps" }, [
                                _c(
                                  "li",
                                  {
                                    class: {
                                      currentApp:
                                        "monitoring" === _vm.currentProduct,
                                    },
                                  },
                                  [
                                    "monitoring" !== _vm.currentProduct
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "monitoring",
                                            attrs: { href: "/#monitoring" },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fal fa-arrow-right",
                                            }),
                                            _vm._v(
                                              "\n                    Monitoring\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    "monitoring" === _vm.currentProduct
                                      ? _c("span", [
                                          _c("i", {
                                            staticClass: "fal fa-arrow-right",
                                          }),
                                          _vm._v(
                                            "\n                    Monitoring\n                  "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: {
                                      currentApp:
                                        "analytics" === _vm.currentProduct,
                                    },
                                  },
                                  [
                                    "analytics" !== _vm.currentProduct
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "analytics",
                                            attrs: { href: "#historical2" },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fal fa-arrow-right",
                                            }),
                                            _vm._v(
                                              "\n                    Analytics\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    "analytics" === _vm.currentProduct
                                      ? _c("span", [
                                          _c("i", {
                                            staticClass: "fal fa-arrow-right",
                                          }),
                                          _vm._v(
                                            "\n                    Analytics\n                  "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.enabledApps.indexOf("workspaces") > -1
                              ? _c(
                                  "li",
                                  {
                                    class: {
                                      optionLink: true,
                                      currentApp:
                                        "workspaces" === _vm.currentProduct,
                                    },
                                  },
                                  [
                                    "workspaces" !== _vm.currentProduct
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "workspaces",
                                            attrs: { href: "/#rooms" },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fal fa-map-marked-alt",
                                            }),
                                            _vm._v(
                                              "\n                Space Insights\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    "workspaces" === _vm.currentProduct
                                      ? _c("span", [
                                          _c("i", {
                                            staticClass:
                                              "fal fa-map-marked-alt",
                                          }),
                                          _vm._v(
                                            "\n                Space Insights\n              "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("section", { staticClass: "account" }, [
                          _c("span", { staticClass: "section-title" }, [
                            _vm._v("Account"),
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "optionList" }, [
                            _vm.showAdmin
                              ? _c(
                                  "li",
                                  {
                                    class: {
                                      optionLink: true,
                                      currentApp:
                                        "admin" === _vm.currentProduct,
                                    },
                                  },
                                  [
                                    "admin" !== _vm.currentProduct
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "adminPortalLink",
                                            attrs: { href: "#/admin/welcome" },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fal fa-toolbox",
                                            }),
                                            _vm._v(
                                              "\n                Admin Portal\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    "admin" === _vm.currentProduct
                                      ? _c("span", [
                                          _c("i", {
                                            staticClass: "fal fa-toolbox",
                                          }),
                                          _vm._v(
                                            "\n                Admin Portal\n              "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("li", { staticClass: "optionLink" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "supportDocs",
                                  attrs: {
                                    target: "_blank",
                                    href: _vm.supportUrl,
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fal fa-newspaper" }),
                                  _vm._v(
                                    "\n                Support Center\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            !_vm.darkMode
                              ? _c("li", { staticClass: "optionLink" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "darkMode",
                                      on: { click: _vm.toggleDarkMode },
                                    },
                                    [
                                      _c("i", { staticClass: "fal fa-moon" }),
                                      _vm._v(
                                        "\n                Try Dark Mode\n                "
                                      ),
                                      _c("em", { staticClass: "beta" }, [
                                        _vm._v("Beta"),
                                      ]),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.darkMode
                              ? _c("li", { staticClass: "optionLink" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "darkMode",
                                      on: { click: _vm.toggleDarkMode },
                                    },
                                    [
                                      _c("i", { staticClass: "fal fa-sun" }),
                                      _vm._v(
                                        "\n                Light Mode\n              "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("li", { staticClass: "optionLink" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "signOut",
                                  on: { click: _vm.signOutFunction },
                                },
                                [
                                  _c("i", { staticClass: "fal fa-sign-out" }),
                                  _vm._v(
                                    "\n                Sign out\n              "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("footer", { staticClass: "userFooter" }, [
                        _c("div", [
                          _vm._v("Signed in as: " + _vm._s(_vm.userName)),
                        ]),
                        _vm._v(" "),
                        _vm._m(3),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.sideLinks && _vm.sideLinks.length > 0 && _vm.expanded
                ? _c(
                    "ul",
                    {
                      staticClass: "sideBarLinks styleScroll",
                      attrs: {
                        "show-arrows": "",
                        "center-active": "",
                        direction: "vertical",
                      },
                    },
                    _vm._l(_vm.sideLinks, function (link, i) {
                      return _c(
                        "li",
                        { key: i, staticClass: "sideLink topLevel" },
                        [
                          link.url && !link.routeName
                            ? _c(
                                "a",
                                {
                                  class: _vm.getLinkClass(
                                    link.url,
                                    _vm.currentUrl
                                  ),
                                  attrs: {
                                    href: link.url,
                                    target: link.target,
                                  },
                                },
                                [
                                  link.icon
                                    ? _c("i", { class: "icon " + link.icon })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(link.title || link.name)),
                                  ]),
                                  _vm._v(" "),
                                  link.badge === "beta"
                                    ? _c("em", { staticClass: "beta" }, [
                                        _vm._v("Beta"),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  link.badge === "alpha"
                                    ? _c("em", { staticClass: "alpha" }, [
                                        _vm._v("Alpha"),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !link.url && !link.routeName
                            ? _c("span", [
                                link.icon
                                  ? _c("i", { class: "icon " + link.icon })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(link.title || link.name)),
                                ]),
                                _vm._v(" "),
                                link.badge === "beta"
                                  ? _c("em", { staticClass: "beta" }, [
                                      _vm._v("Beta"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                link.badge === "alpha"
                                  ? _c("em", { staticClass: "alpha" }, [
                                      _vm._v("Alpha"),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          link.routeName
                            ? _c(
                                "router-link",
                                {
                                  class: _vm.getLinkClass(
                                    link.url,
                                    _vm.currentUrl
                                  ),
                                  attrs: {
                                    to: {
                                      name: link.routeName,
                                      params: link.params,
                                    },
                                  },
                                },
                                [
                                  _c("i", { class: link.icon }),
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(link.title || link.name) +
                                      "\n          "
                                  ),
                                  link.badge === "beta"
                                    ? _c("em", { staticClass: "beta" }, [
                                        _vm._v("Beta"),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  link.badge === "alpha"
                                    ? _c("em", { staticClass: "alpha" }, [
                                        _vm._v("Alpha"),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          link.views && link.views.length > 0
                            ? _c(
                                "ul",
                                { staticClass: "sublevelLinks" },
                                _vm._l(link.views, function (view, j) {
                                  return _c(
                                    "li",
                                    {
                                      key: j,
                                      staticClass: "sideLink subLevel",
                                    },
                                    [
                                      !view.routeName
                                        ? _c(
                                            "a",
                                            {
                                              class: _vm.getLinkClass(
                                                view.url,
                                                _vm.currentUrl
                                              ),
                                              attrs: {
                                                href: view.url,
                                                target: view.target,
                                              },
                                            },
                                            [
                                              view.icon
                                                ? _c("i", {
                                                    class: "icon " + view.icon,
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    view.title || view.name
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              view.badge === "beta"
                                                ? _c(
                                                    "em",
                                                    { staticClass: "beta" },
                                                    [_vm._v("Beta")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              view.badge === "alpha"
                                                ? _c(
                                                    "em",
                                                    { staticClass: "alpha" },
                                                    [_vm._v("Alpha")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      view.routeName
                                        ? _c(
                                            "router-link",
                                            {
                                              class: _vm.getLinkClass(
                                                view.url,
                                                _vm.currentUrl
                                              ),
                                              attrs: {
                                                to: {
                                                  name: view.routeName,
                                                  params: view.params,
                                                },
                                              },
                                            },
                                            [
                                              _c("i", { class: view.icon }),
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    view.title || view.name
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      view.tabs
                                        ? _c(
                                            "ul",
                                            _vm._l(
                                              view.tabs,
                                              function (tab, k) {
                                                return _c("li", {
                                                  key: k,
                                                  staticClass:
                                                    "sideLink bottomLevel",
                                                })
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("body"),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "productName" }, [
      _c("div", { staticClass: "topLine" }, [_vm._v("Technology Insights")]),
      _vm._v(" "),
      _c("div", { staticClass: "bottomLine" }, [
        _c("i", { staticClass: "fal fa-arrow-right" }),
        _vm._v("\n            Monitoring\n          "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "productName" }, [
      _c("div", { staticClass: "topLine" }, [_vm._v("Technology Insights")]),
      _vm._v(" "),
      _c("div", { staticClass: "bottomLine" }, [
        _c("i", { staticClass: "fal fa-arrow-right" }),
        _vm._v("\n            Analytics\n          "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "techTitle" }, [
      _c("i", { staticClass: "fal fa-monitor-heart-rate" }),
      _vm._v("\n                Technology Insights\n              "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "eula-section" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.hp.com/us-en/privacy/privacy-central.html",
            target: "_blank",
          },
        },
        [_vm._v("Privacy Statement")]
      ),
      _vm._v(",\n        "),
      _c(
        "a",
        {
          attrs: {
            href: "https://support.hp.com/us-en/document/ish_12775809-12775790-16",
            target: "_blank",
          },
        },
        [_vm._v("EULA")]
      ),
      _vm._v(",\n        and "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf",
            target: "_blank",
          },
        },
        [_vm._v("DPA")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }